import React from 'react';
import { StyledP, StyledA } from 'components';
import { numberToUSD } from 'helpers/currency';
import { userLocatedInAmerica } from 'helpers/http';

interface CartPriceProps {
  value?: number | string;
  className?: string;
  isFinalStep?: boolean;
}

const USD_HELP_PAGE = 'https://help.artifactuprising.com/hc/en-us/articles/360011531631-Are-All-Prices-Shown-in-USD-';
const userIsInAmerica = userLocatedInAmerica();

const CartPrice = ({value, className, isFinalStep = false }: CartPriceProps): JSX.Element => {
  const maybeAddUSD = () => !userIsInAmerica ? ' USD' : '';
  const maybeLinkToHelpPage = (child) => {
      if (!userIsInAmerica && isFinalStep) {
          return <StyledA href={USD_HELP_PAGE}>{child}</StyledA>;
      }
      return child;
  };

  let price;
  if (isNaN(value)) {
    price = value;
  } else {
    if (typeof value == 'string') {
      value = parseFloat(value);
    }
    price = numberToUSD(value) + maybeAddUSD();
  }
   
  return (
      maybeLinkToHelpPage(<StyledP secondary className={className}>{price}</StyledP>)
  );
};

export default CartPrice;
